import { render } from "./App.vue?vue&type=template&id=08c753ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=08c753ec&lang=css"
script.render = render

export default script